/**
 * Marlow Product Video - Autoplay and Play/Pause Controls
 */

document.addEventListener('DOMContentLoaded', function() {
  const videoWrappers = document.querySelectorAll('.marlow-product-video__video-inner[data-video-autoplay="true"]');
  
  videoWrappers.forEach(function(videoWrapper) {
    const video = videoWrapper.querySelector('.marlow-product-video__video');
    const playToggle = videoWrapper.querySelector('.marlow-product-video__play-toggle');
    const playIcon = videoWrapper.querySelector('.marlow-product-video__play-icon');
    const pauseIcon = videoWrapper.querySelector('.marlow-product-video__pause-icon');
    
    if (!video) return;
    
    // Update button icons
    function updatePlayButton(showPlay) {
      if (playIcon && pauseIcon) {
        playIcon.style.display = showPlay ? 'block' : 'none';
        pauseIcon.style.display = showPlay ? 'none' : 'block';
      }
    }
    
    // Intersection Observer for autoplay
    const observerOptions = {
      threshold: 0.5,
      rootMargin: '0px'
    };
    
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          video.play().catch(function(err) {
            console.log('Autoplay prevented:', err);
          });
          updatePlayButton(false);
        } else {
          video.pause();
          updatePlayButton(true);
        }
      });
    }, observerOptions);
    
    observer.observe(videoWrapper);
    
    // Play/Pause toggle button
    if (playToggle) {
      playToggle.addEventListener('click', function() {
        if (video.paused) {
          video.play();
          updatePlayButton(false);
        } else {
          video.pause();
          updatePlayButton(true);
        }
      });
    }
    
    // Update button on video events
    video.addEventListener('play', function() {
      updatePlayButton(false);
    });
    
    video.addEventListener('pause', function() {
      updatePlayButton(true);
    });
  });
});
